import { denormalizedEntitySelector } from 'entities/selectors'

import { queryPosts } from 'wordpress/actions'
import { promotionSchema } from 'wordpress/schemas'
import { entitySelector, componentSelector } from 'wordpress/selectors'
import { withWordpressLanguage } from 'wordpress/utils'

import '../styles/promotions.scss'

class Promotions extends Component {
    componentDidMount() {
        const { queryPosts, id } = this.props

        queryPosts('promotions', {
            locations: id,
            isActive: true,
        })

        queryPosts('media', {
            locations: id,
        })
    }

    render() {
        const { featImage, promotions, widget } = this.props
        const { enabled, linkAction, page, url } = widget

        if (!promotions.length || !enabled) return null

        const getLink = (title, children) => {
            const props = {
                ...(linkAction === 'page' ? { to: page } : { href: url }),
            }

            return linkAction === 'page' ? (
                <Link {...props}>
                    {title}
                    {children}
                </Link>
            ) : (
                <a {...props}>
                    {title}
                    {children}
                </a>
            )
        }

        return (
            <div className="container-fluid promotions">
                <div className="container p-0">
                    <div className="content">
                        {!!featImage.length && (
                            <div className="image">
                                <Image image={featImage[0]} />
                            </div>
                        )}
                        <div className="content-wrapper">
                            <h2>
                                <T>car.park.promotions.title</T>
                            </h2>
                            <hr />
                            <ul>
                                {promotions.map(({ title }, i) => (
                                    <li key={i}>{getLink(title, <i className="arrow-right" />)}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const idSelector = (state, props) => props.id
const entitiesByLocationSelector = entities =>
    createSelector(idSelector, entities, (id, results) =>
        Object.keys(results)
            .map(o => (results[o].locations.indexOf(id) >= 0 ? results[o] : false))
            .filter(Boolean)
    )

export default compose(
    withWordpressLanguage,
    connect(
        createStructuredSelector({
            featImage: entitiesByLocationSelector(entitySelector('media')),
            promotions: entitiesByLocationSelector(denormalizedEntitySelector(promotionSchema)),
            widget: componentSelector('promotionsRibbon'),
        }),
        { queryPosts }
    )
)(Promotions)
